import { addBetFactory } from 'app/modules/BetSlip/actions/addBetFactory';

import { matches, objects, sports } from './selectors/entities';

// ---

export const MATCH_OF_THE_DAY_TOPIC = 'matches-of-the-day';

export const addBet = addBetFactory(matches, sports, objects);
